var map = {
	"./10_nuts.png": 2476,
	"./1drink_12beer.png": 2477,
	"./1serving_8ounces.png": 2478,
	"./1serving_8ounces2.png": 2479,
	"./1serving_8ounces3.png": 2480,
	"./1serving_8ounces4.png": 2481,
	"./1serving_8ounces5.png": 2482,
	"./8ounces_1glass.png": 2483,
	"./can_1.png": 2484,
	"./can_2.png": 2485,
	"./can_3.png": 2486,
	"./cup.png": 2487,
	"./dried_serving_1/4cup.png": 2488,
	"./dried_serving_1:4cup.png": 2489,
	"./fresh_serving_1cup.png": 2490,
	"./glass_1.png": 2491,
	"./glass_2.png": 2492,
	"./golfball.png": 2493,
	"./halfthumb.png": 2494,
	"./hand_1.png": 2495,
	"./hand_2.png": 2496,
	"./hand_3.png": 2497,
	"./hand_4.png": 2498,
	"./hand_5.png": 2499,
	"./how.png": 870,
	"./serving_1/2cup.png": 2500,
	"./serving_1:2cup.png": 2501,
	"./serving_1tbsp.png": 2502,
	"./serving_3/4ounces.png": 2503,
	"./serving_3:4ounces.png": 2504,
	"./thumbx2.png": 2505,
	"./usda.png": 2506,
	"./vegetables_1cup.png": 2507,
	"./what.png": 868,
	"./wholethumb.png": 2508,
	"./why.png": 869
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2475;